var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41425 5.00001L9.70725 1.70701C10.0982 1.31601 10.0982 0.684006 9.70725 0.293006C9.31625 -0.0979941 8.68425 -0.0979941 8.29325 0.293006L5.00025 3.58601L1.70725 0.293006C1.31625 -0.0979941 0.68425 -0.0979941 0.29325 0.293006C-0.09775 0.684006 -0.09775 1.31601 0.29325 1.70701L3.58625 5.00001L0.29325 8.29301C-0.09775 8.68401 -0.09775 9.31601 0.29325 9.70701C0.48825 9.90201 0.74425 10 1.00025 10C1.25625 10 1.51225 9.90201 1.70725 9.70701L5.00025 6.41401L8.29325 9.70701C8.48825 9.90201 8.74425 10 9.00025 10C9.25625 10 9.51225 9.90201 9.70725 9.70701C10.0982 9.31601 10.0982 8.68401 9.70725 8.29301L6.41425 5.00001Z",
    fill: "#7256CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.4a65acc650494cff2969f19ec42d66d4.svg";
export { ForwardRef as ReactComponent };